<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <d-row no-gutters class="page-header py-4">
            <d-col class="text-center text-sm-left flex-header mb-sm-0">
                <h3 class="page-title">Nowy wydatek</h3>
                <d-button theme="secondary" @click.prevent="$router.push({name: 'expenses-list'})"><i class="material-icons">keyboard_backspace</i> Wróć do listy</d-button>
                <d-button :class="{isLoading : submitting}" theme="success" @click.prevent="submitForm"><i class="material-icons">add</i> Dodaj wydatek</d-button>
            </d-col>
        </d-row>

        <div v-if="!fetched">
            <h2 class="preloader isLoading">Trwa ładowanie</h2>
        </div>
        <transition name="fade">
            <d-card class="card-small" v-if="fetched">
                <d-card-header>
                    <h6 class="m-0">Szczegóły wydatku</h6>
                </d-card-header>
                <d-list-group flush>
                    <d-list-group-item class="p-3">
                        <d-form>
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <label>Użytkownik</label>
                                    <ss-autocomplete @optionSelected="userSelectedHanlder"
                                                     :placeholder="'Użytkownik'"
                                                     :class="{'is-invalid' : lar_errors.has('user_id') }"
                                                     :options="allUsers"
                                                     :value="expense.user_id.toString()" />
                                    <div class="invalid-feedback" v-text="lar_errors.get('user_id')"></div>
                                </d-col>
                            </d-form-row>
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <label>Suma</label>
                                    <ss-price-input type="text"
                                                    name="amount"
                                                    v-model="expense.amount"
                                                    @input="lar_errors.clear('amount')"
                                                    :class="{'is-invalid' : lar_errors.has('amount')}"
                                                    placeholder=""/>
                                    <div class="invalid-feedback" v-text="lar_errors.get('amount')"></div>
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <label>Sposób płatności</label>
                                    <d-select size="sm" v-model="expense.payment_type"
                                              @input="lar_errors.clear('payment_type')"
                                              :class="{'is-invalid' : lar_errors.has('payment_type') }">
                                        <option value="cash">Gotówka</option>
                                        <option value="transfer">Przelew</option>
                                    </d-select>
                                    <div class="invalid-feedback" v-text="lar_errors.get('payment_type')"></div>
                                    <d-checkbox
                                            class="mt-2 yes-no"
                                            v-if="expense.payment_type === 'transfer'"
                                            :value="'1'"
                                            :unchecked-value="'0'"
                                            toggle
                                            v-model="expense.transfer_complete">
                                        Zrealizowany
                                    </d-checkbox>
                                    <d-checkbox
                                            class="mt-2 yes-no"
                                            v-if="expense.payment_type === 'cash'"
                                            :value="'1'"
                                            :unchecked-value="'0'"
                                            toggle
                                            v-model="expense.cash_refunded">
                                        Wykonano zwrot
                                    </d-checkbox>
                                </d-col>
                            </d-form-row>
                            <d-form-row  v-if="expense.payment_type === 'transfer'">
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="expense.transfer_title" name="transfer_title" label="Tytuł przelewu" placeholder="Tytuł przelewu"></ss-input>
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="expense.account_number" name="account_number" label="Numer konta" placeholder="Numer konta bankowego"></ss-input>
                                </d-col>
                            </d-form-row>
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <label>Typ kosztu</label>
                                    <d-select size="sm"
                                              v-model="expense.expenses_cost_type"
                                              :class="{'is-invalid' : lar_errors.has('expenses_cost_type') }"
                                              @input="lar_errors.clear('expenses_cost_type')">
                                        <option :value="cost.id" v-for="cost in allCostTypes" :key="cost.id">{{ cost.name }}</option>
                                    </d-select>
                                    <div class="invalid-feedback" v-text="lar_errors.get('expenses_cost_type')"></div>
                                </d-col>
                                <d-col md="6" class="form-group" v-if="expense.expenses_cost_type === 1">
                                    <label>Komornik</label>
                                    <div class="d-flex" :class="{'is-invalid' : lar_errors.has('bailiff_id') }">
                                        <v-select
                                                class="w-100"
                                                :options="allBailiffs"
                                                v-model="expense.bailiff_id"
                                                @input="lar_errors.clear('bailiff_id')"
                                                :reduce="bailiff => bailiff.id"
                                                placeholder="Wpisz dane komornika..."
                                                label="name">
                                            <span slot="no-options">
                                              Brak wyników
                                            </span>
                                        </v-select>
                                        <d-button class="wsnw ml-4" @click.prevent="newBailiffModal = true">Dodaj komornika</d-button>
                                    </div>
                                    <div class="invalid-feedback" v-text="lar_errors.get('bailiff_id')"></div>
                                </d-col>
                                <d-col md="6" class="form-group" v-if="expense.expenses_cost_type === 2">
                                    <label>Nazwa sądu</label>
                                    <div class="d-flex" :class="{'is-invalid' : lar_errors.has('court_id') }">
                                        <v-select
                                                class="w-100"
                                                :options="allCourts"
                                                v-model="expense.court_id"
                                                @input="lar_errors.clear('court_id')"
                                                :reduce="court => court.id"
                                                placeholder="Wpisz dane sądu..."
                                                label="name">
                                            <span slot="no-options">
                                              Brak wyników
                                            </span>
                                        </v-select>
                                        <d-button class="wsnw ml-2" @click.prevent="isCourtModalVisible = true">Dodaj sąd</d-button>
                                    </div>
                                    <div class="invalid-feedback" v-text="lar_errors.get('court_id')"></div>
                                </d-col>
                                <d-col md="6" class="form-group" v-if="expense.expenses_cost_type === 3">
                                    <ss-input v-model="expense.recipent" name="recipent" label="Odbiorca" placeholder="Odbiorca"></ss-input>
                                </d-col>
                            </d-form-row>
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <label>Połącz z umową</label>
                                    <schedules-autocomplete
                                            :class="{'is-invalid' : lar_errors.has('schedule_id') }"
                                            @optionSelected="scheduleSelected(expense, $event)"
                                            style="max-width: 100%;"></schedules-autocomplete>
                                    <div class="invalid-feedback" v-text="lar_errors.get('schedule_id')"></div>
                                </d-col>
                                <d-col md="6" class="form-group" v-if="expense.schedule_id">
                                    <label>Połącz ze sprawą egzekucyjną</label>
                                    <d-select size="sm" v-model="expense.contract_case_id" >
                                        <option :value="contract_case.id" v-for="contract_case in executions" :key="contract_case.id">{{ (contract_case.number? contract_case.number : 'brak numeru umowy') + (contract_case.consignment_number ? ', Numer listu przewozowego: ' + contract_case.consignment_number : ', brak numeru listu przewozowego') }}</option>
                                    </d-select>
                                </d-col>
                            </d-form-row>
                            <div class="form-group">
                                <ss-textarea v-model="expense.comment"
                                             name="comment"
                                             label="Komentarz"
                                             placeholder="Komentarz"></ss-textarea>
                            </div>
                        </d-form>
                    </d-list-group-item>
                </d-list-group>
                <ss-modal
                        class="xl"
                        v-if="newBailiffModal"
                        title="Title"
                        intro="bounceIn"
                        outro ="bounceOut">
                    <div slot = "modal-header">
                        Dodawanie komornika
                    </div>
                    <div slot="modal-body">
                        <bailiff-form></bailiff-form>
                    </div>
                    <div slot = "modal-footer">
                        <d-button @click.prevent="newBailiffModal = false" theme="danger"><i class="material-icons">close</i> Anuluj</d-button>
                        <d-button @click.prevent="$bus.$emit('new-bailiff-save')" theme="success" class="ml-4"><i class="material-icons">save</i> Zapisz komornika</d-button>
                    </div>
                </ss-modal>
            </d-card>
        </transition>
        <court-modal
          :show="isCourtModalVisible" />
    </d-container>
</template>

<script>
  import LarErrors from '../helpers/Errors';
  import expenseUtil from '../utils/expense'
  import SsPriceInput from '../components/common/SsPriceInput'
  import SsAutocomplete from '../components/common/SsAutocomplete'
  import SchedulesAutocomplete from '../components/common/SsSchedulesAutocomplete';
  import SsNameAutocomplete from '../components/common/SsNameAutocomplete';
  import SsBailiffsAutocomplete from "../components/common/SsBailiffsAutocomplete";
  import CourtModal from '../components/courts/CourtModal';
  import BailiffForm from '../components/bailiffs/BailiffForm'
  import SsModal from '../components/common/SsModal';
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: "expenseNew",
    components: {
      SsBailiffsAutocomplete,
      SsNameAutocomplete,
      LarErrors,
      SsPriceInput,
      SsAutocomplete,
      SchedulesAutocomplete,
      CourtModal,
      BailiffForm,
      SsModal
    },
    data(){
      return{
        fetched: false,
        lar_errors: LarErrors,
        submitting: false,
        cost_types: [],
        expense: _.clone(expenseUtil),
        executions: [],
        newBailiffModal: false,
        isCourtModalVisible: false,
        court: {
          name: '',
          id: null
        }
      }
    },
    computed: {
      ...mapGetters([
        'allUsers',
        'allCostTypes',
        'allCourts',
        'allBailiffs'
      ]),
    },
    methods: {
      ...mapActions([
        'getAllUsers',
        'getAllCostTypes',
        'getAllCourts',
        'getAllBailiffs'
      ]),
      submitForm(){
        this.submitting = true;
        axios.post('api/expenses/store', this.expense).then(response => {
          Vue.swal({
            type: 'success',
            title: 'Wydatek został dodany.',
            showConfirmButton: true,
          }).then(() => {
            this.$router.push({name: 'expenses-list'});
          });
          this.submitting = false;
        }).catch((error) =>{
            Vue.swal({
                type: 'error',
                title: error.response.data.message,
                html: Vue.transformErrorsToHtml(error.response.data.errors),
                showConfirmButton: true,
            });
            this.submitting = false;
            LarErrors.record(error.response.data.errors)
        })
      },
      userSelectedHanlder(id) {
        this.lar_errors.clear('user_id');
        this.expense.user_id = id
      },
      scheduleSelected(a, b){
        this.lar_errors.clear('schedule_id');
        a.schedule_id = b.id;
        axios.post('api/contracts-case/get-cases/' + b.id).then(response => {
          this.executions = response.data;
        }).catch((errors) =>{
          console.log(errors);
        })
      },
      newCourtAdded(isAdded, newCourt) {
        this.isCourtModalVisible = false;
        if (!isAdded) {
          return;
        }
        this.getAllCourts();
        this.expense.court_id = newCourt.id
      },
      newBailiffAdded(bailiff) {
        this.getAllBailiffs();
        this.newBailiffModal = false;
        this.expense.bailiff_id = bailiff.id
      }
    },
    mounted(){
      this.$bus.$on('new-bailiff-saved', this.newBailiffAdded);
      this.$bus.$on('court-modal-hide', this.newCourtAdded);
      this.getAllCostTypes();
      this.getAllUsers();
      this.getAllCourts();
      this.getAllBailiffs();
      this.fetched = true;
    },
    beforeDestroy() {
      this.$bus.$off('new-bailiff-saved', this.newBailiffAdded);
      this.$bus.$off('court-modal-hide', this.newCourtAdded);
    }
  }
</script>
